import type { FC } from "react"

interface PaymentCancelParams {
  session_id: string
}

const PaymentCancel: FC<PaymentCancelParams> = () => {
  return (
    <div>
      <h1>Payment Cancelled</h1>

      <p>
        Your payment was cancelled. Return to{" "}
        <a href="https://www.procircular.com/">ProCircular</a> to continue
        shopping.
      </p>
    </div>
  )
}

export default PaymentCancel
